// extracted by mini-css-extract-plugin
export default {"tbody":"TbodySuccess_tbody__JfaNz"};